module.exports = __webpack_public_path__ + "img/img93.39d6f2b7.png";